/* eslint-disable react/jsx-props-no-spreading */
import DropZone, { DropFilesEventHandler } from 'react-dropzone';
import { plural } from '../../../../shared/helpers';
import Button, { ButtonGroup } from '../../generic/Button';
import Flex from '../../generic/Flex';
import { icons, IconText } from '../../generic/Icon';

type UploadHeaderProps = {
  numUploads: number;
  onDropAdditionalFiles: DropFilesEventHandler;
  acceptedFileTypes: Record<string, string[]>;
  onUpload: () => void;
  isUploadEnabled: boolean;
};

const UploadComponentHeader = ({
  numUploads,
  onDropAdditionalFiles,
  acceptedFileTypes,
  isUploadEnabled,
  onUpload,
}: UploadHeaderProps) => (
  <Flex direction="row" grow={1} justify="flex-end">
    <ButtonGroup spacing="lg">
      <DropZone
        onDrop={onDropAdditionalFiles}
        accept={acceptedFileTypes}
      >
        {
          ({ getRootProps, getInputProps }) => (
            <>
              <span className="add-uploads-wrapper" {...getRootProps()}>
                <IconText
                  icon={icons.plus}
                  text="Add Files"
                />
              </span>
              <input {...getInputProps()} />
            </>
          )
        }
      </DropZone>
      <Button
        type="primary"
        size="large"
        icon={icons.upload}
        isDisabled={!isUploadEnabled || numUploads === 0}
        onClick={onUpload}
      >
        <IconText
          icon={icons.caretRight}
          text={`Upload ${numUploads} ${plural(numUploads, 'file')}`}
          alignIcon="right"
        />
      </Button>
    </ButtonGroup>
  </Flex>
);

export default UploadComponentHeader;
